import React from "react"

import { ProjectTeamInvitationListPage as ProjectTeamInvitationListPageObj } from "scrivito/Objs/ProjectTeamInvitationListPage/ProjectTeamInvitationListPageObjClass"

import { useTeamInvitationListModel } from "features/project-team/ui/project-team-invitation-list/model/useProjectTeamInvitationListModel"

import { ProjectTeamInvitationListPage } from "./ProjectTeamInvitationListPage"

export const ProjectTeamInvitationListPageConnector = React.memo(
  ({ page }: { page: ProjectTeamInvitationListPageObj }) => {
    return (
      <ProjectTeamInvitationListPage
        {...useTeamInvitationListModel()}
        page={page}
      />
    )
  }
)
